var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('Header',{ref:"header"}),_c('div',{staticClass:"main"},[_c('router-view')],1),_c('Footer',{directives:[{name:"show",rawName:"v-show",value:(_vm.access!='userInfo'),expression:"access!='userInfo'"}]}),_c('sliderBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }